module.exports = __webpack_public_path__ + "img/ingredienten-spaghetti-carbonara.6b2b7fec.jpeg";